import JsCookie from 'js-cookie';

JsCookie.defaults.domain = process.env.app.glazeprosthetics.com;
JsCookie.defaults.path = process.env.VUE_APP_COOKIE_PATH;

export const Cookies = JsCookie;
